import React from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";
import showdown from "showdown";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(currentActivity.websiteData.faq.subtitle);
  return (
    currentActivity &&
    currentActivity.websiteData &&
    currentActivity.websiteData.faq.data.length > 0 && (
      <div
        id="faq"
        className="gradiant-background pwg-section contact-section section pt-90 pb-10"
      >
        <div className="container tab-fix">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 mb-4 text-center">
              <h2 className="heading heading-light ">
                {currentActivity.websiteData.faq.title
                  ? currentActivity.websiteData.faq.title
                  : "FAQ"}
              </h2>
              {currentActivity.websiteData.faq.subtitle && (
                <p
                  className="h4 heading-light mb-6"
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row mb-60">
          <div className="col-md-10 col-md-offset-1">
            <div className="box contact-form mb-0 white-bg ">
              <div className="container">
                <div className="faq-alt">
                  <div className="row tab-fix">
                    <div className="col-md-10 ">
                      <div
                        className="panel-group accordion"
                        id="another"
                        role="tablist"
                        aria-multiselectable="true"
                      >
                        {currentActivity.websiteData.faq.data.map(
                          (faq, index) => {
                            return (
                              <div
                                className="panel panel-default pt-10 pb-10"
                                key={index}
                              >
                                <div
                                  className="panel-heading"
                                  role="tab"
                                  id={`accordion-i${index}`}
                                >
                                  <h6 className="panel-title">
                                    <a
                                      className=""
                                      role="button"
                                      data-toggle="collapse"
                                      data-parent="#another"
                                      aria-expanded="false"
                                      href={`#accordion-pane-i${index}`}
                                      style={{ color: "#313e48" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                      }}
                                    >
                                      {index + 1}- {faq.question}
                                      <span className="plus-minus">
                                        <span />
                                      </span>
                                    </a>
                                  </h6>
                                </div>
                                <div
                                  id={`accordion-pane-i${index}`}
                                  className="panel-collapse collapse"
                                  role="tabpanel"
                                  aria-labelledby={`accordion-i${index}`}
                                >
                                  <div className="panel-body">
                                    {faq.response
                                      .split("</br>")
                                      .map((str, i) => {
                                        return <p key={i}>{str}</p>;
                                      })}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

// const faqs = [
//   {
//     key: 1,
//     question: "Qu'est-ce que Prévoithon by CDG Prévoyance?",
//     response:
//       "C’est le premier programme d’open innovation de CDG Prévoyance, en partenariat avec LaFactory by Screendy, dans lequel des équipes multidisciplinaires composées de profils complémentaires internes à l’entreprise et externes (startups, porteurs d’idées, développeurs, spécialistes du marketing, concepteurs, etc.) se réunissent pour co-développer des solutions innovantes afin de faciliter la vie des clients (Retraités, bénéficiaires de pensions et de rentes …) C'est une expérience humaine unique qui permet aux participants de se rencontrer et d'interagir avec des collègues et des experts. À la fin de l'événement, un jury composé du Top Management de la CDG, choisit les meilleurs solution afin de les rendre disponibles pour les clients. Vous voulez savoir à quoi ressemble un Hackathon? <a href='https://www.youtube.com/watch?v=6rihdSyAcdo' target='_blanc'>Cliquez ici </a>",
//   },
//   {
//     key: 2,
//     question: "Quand aura t-il lieu ?",
//     response:
//       "L’appel à candidature s’ouvrira le 27 Novembre et se prolongera jusqu’au 08 décembre 2019. Le hackathon aura lieu à Rabat les 13, 14 et 15 décembre 2019.",
//   },
//   {
//     key: 3,
//     question: "Comment participer?",
//     response:
//       "Vous pouvez participer au programme Prévoithon by CDG Prevoyance  en remplissant le formulaire d'inscription et en le soumettant avant le 08 décembre 2019.",
//   },
//   {
//     key: 4,
//     question: "Qui peut participer?",
//     response:
//       "Tout le monde peut candidater à ce programme ! Que vous soyez issus de l’écosystème interne de CDG Prévoyance (collaborateurs, partenaires privés ou publics, fournisseurs, etc.) ou externe : startups et aspirants entrepreneurs. Vous pouvez tous aider à trouver des solutions pertinentes pour des centaines de milliers de citoyens marocains !",
//   },
//   {
//     key: 5,
//     question: "Qui travaillera sur les Challenges?",
//     response:
//       "La compétition se déroulera en équipes composées des membres de la startup et des collaborateurs de CDG Prévoyance.",
//   },

//   {
//     key: 7,
//     question: "Comment puis-je augmenter mes chances d'être sélectionné?",
//     response:
//       "Pour augmenter vos chances, vous devez soumettre autant d'éléments et de documents de référence que possible. Aidez-nous à mieux vous connaître: vos qualifications, vos motivations à participer, vos réalisations personnelles et d'équipe et votre solution actuelle.",
//   },
//   {
//     key: 8,
//     question:
//       " Les participants peuvent-ils utiliser leurs ordinateurs portables personnels?",
//     response:
//       "Oui, les candidats sont invités à apporter leurs propres ordinateurs. Sinon, des ordinateurs seront mis à la disposition des participants pendant les trois jours de l'événement.",
//   },
//   {
//     key: 9,
//     question: "La restauration est-elle disponible sur place?",
//     response:
//       "Oui, la restauration sera assurée et des collations seront servies pendant toute la durée des événements.",
//   },

//   {
//     key: 10,
//     question:
//       "Ma présence est-elle obligatoire sur le site pendant toute la durée de l'événement?",
//     response:
//       "Oui, c'est l'esprit des événements d'Open Innovation. L'espace de travail fournit un environnement idéal pour des sessions de travail intenses.",
//   },
//   {
//     key: 11,
//     question: "Que dois-je apporter pour l'événement?",
//     response:
//       "De la bonne humeur, de l’esprit de compétition et surtout des idées innovantes !",
//   },
//   {
//     key: 12,
//     question:
//       "Vous voulez savoir à quoi ressemble un Hackathon? Regardez la vidéo ci dessous",
//     response:
//       "<a href='https://www.youtube.com/watch?v=6rihdSyAcdo' target='_blank'>Cliquez ici</a>",
//   },
// ];
